<h1 i18n>Give your idea a title</h1>
<rr-input label="Title" [FormControl]="name"></rr-input>
<div class="w100 row justify-end gap-8">
  <rr-btn type="Secondary" (click)="cancel()">Cancel</rr-btn>
  <rr-btn type="Primary" (click)="startTrack()">OK</rr-btn>
</div>
<rr-spinner *ngIf="showLoading"></rr-spinner>
